import "lightgallery/css/lg-thumbnail.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lightgallery.css";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";
import LightGallery from "lightgallery/react";
import React, { useEffect, useState, useRef } from "react";
import {
  Col,
  Container,
  Form,
  Row,
  Spinner,
  Table,
} from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";

import ImageElement from "components/ImageElement";
import { getVideoDuration, formatSecondsToHMS, removeBordersFromCursorPointerImages } from "utils/helpers";

import { BROKER_ENDPOINT } from "apiEndpoints";
import RangeSlider from "react-range-slider-input";
import "react-range-slider-input/dist/style.css";
import userRouteMap from "routes/User/userRouteMap";
import { commonService } from "services/common.service";
import socketEventManager from "socket/socketEvents";

const userData = JSON.parse(localStorage.getItem('userData') || '{}');

function MeetingFloorPlan() {
  const location = useLocation();
  const navigate = useNavigate();
  const [state, setState] = useState({
    isLoading: true,
    lists: [],
    filteredLists: [], // Store filtered results
    originalLists: [], // Store original data for resetting filters
    filterDetails: null,
    propertyData: {
      isLoading: true,
      lists: [],
    },
    selectFilter: {
      bedroomCount: [],
      building: [],
      residenceType: [],
      entry: [],
      view: [],
      exterior: [],
      ceilingHeight: [],
      kitchenDining: [],
      bath: [],
      closet: [],
      bonusRooms: [],
      hvac: [],
    },
    selectTableRow: null,
    // isOpenFilter: false,
    isCompare: false,
    compareImageLists: [],
    selectedRowsImages : [],
  });

  // Check if private mode is enabled
  const localValue = localStorage.getItem("privateMode");
  const isPrivateMode = localValue === "true";

  // Range slider states
  const [value1, setValue1] = useState([0, 6300000]); // Price
  const [value2, setValue2] = useState([0, 6300000]); // Square Feet
  const [value3, setValue3] = useState([0, 40]); // Floor
  const [imageArray, setImageArray] = useState([]);

  const [galleryEnabled, setGalleryEnabled] = useState(true);
  const [selectedVideoItem, setSelectedVideoItem] = useState(null);

  const min = 0;
  const max = 6300000;
  const floorMin = 0;
  const floorMax = 40;

  const [screenPlayerIds, setScreenPlayerIds] = useState({
    left: null,
    right: null,
  });

  const screenPlayerIdsRef = useRef({ left: null, right: null });

  // Add favoriteUnits state
  const [favoriteUnits, setFavoriteUnits] = useState(() => {
    try {
      const fav = localStorage.getItem('favoriteUnits');
      return fav ? JSON.parse(fav) : [];
    } catch {
      return [];
    }
  });
  useEffect(() => {
    localStorage.setItem('favoriteUnits', JSON.stringify(favoriteUnits));
  }, [favoriteUnits]);
  const handleFavChange = (unitId) => {
    setFavoriteUnits((prev) =>
      prev.includes(unitId)
        ? prev.filter((id) => id !== unitId)
        : [...prev, unitId]
    );
  };

  const applyFilters = (
    items,
    filters,
    priceRange,
    squareFeetRange,
    floorRange
  ) => {
    if (!items || !items.length) return [];

    return items.filter((item) => {
      // Filter by price (if price exists)
      if (
        item.price &&
        (item.price < priceRange[0] || item.price > priceRange[1])
      ) {
        return false;
      }

      // Filter by square feet (if sqft_int exists and is numeric)
      const sqft = parseInt(item.sqft_int, 10);
      if (
        !Number.isNaN(sqft) &&
        (sqft < squareFeetRange[0] || sqft > squareFeetRange[1])
      ) {
        return false;
      }

      // Filter by floor (if floor exists and is numeric)
      const floor = parseInt(item.floor, 10);
      if (!Number.isNaN(floor) && (floor < floorRange[0] || floor > floorRange[1])) {
        return false;
      }

      // Filter by bedroom count
      if (filters.bedroomCount.length > 0) {
        // Special case for "Suites" (empty bedrooms)
        if (filters.bedroomCount.includes("Suites") && item.bedrooms === "") {
          // Pass this check
        } else if (!filters.bedroomCount.includes(item.bedrooms)) {
          return false;
        }
      }

      // Filter by building
      if (
        filters.building.length > 0 &&
        !filters.building.includes(item.building)
      ) {
        return false;
      }

      // Filter by residence type
      if (
        filters.residenceType.length > 0 &&
        !filters.residenceType.includes(item.kind)
      ) {
        return false;
      }

      // For other filters that might need more complex logic or don't directly map to data fields,
      // additional code would be required

      return true;
    });
  };
  
  async function handleRotateLongPress(item, eventType, direction) {

    let videoAction;
    let isSeek = "false";
    switch (eventType) {
      case "play":
        videoAction = "play";
        isSeek = "true";
        break;
      case "pause":
        videoAction = "pause";
        break;
      case "press":
        videoAction = direction === "left" ? "backward" : "forward";
        break;
      case "release":
        videoAction = "pause";
        break;
      default:
        videoAction = "none";
    }

    // Get video duration using utility functions
    let currentTime = "00:00:00";
    
    if (item?.image_url) {
      try {
        const duration = await getVideoDuration(item.image_url);
        
        if (duration && !Number.isNaN(duration)) {
          currentTime = formatSecondsToHMS(duration);
        }
      } catch (error) {
        console.warn('Error getting video duration:', error);
        currentTime = "00:00:00";
      }
    }

    const primarySocketObjectEvent = {
      hardware_id: item?.hardware_id,
      broker_id: userData.id,
      sub_sub_category_id: item?.sub_sub_category_id,
      type: item?.type,
      video_id: item?.id,
      action: videoAction,
      current_time: currentTime, // use the actual duration
      opening_frame: item?.opening_frame,
      video_url: item?.image_url,
      frame_rate: "30",
      is_seek: isSeek,
      video_loop: "yes",
    };
    console.log("rotateSocketObjectEvent", primarySocketObjectEvent);
    socketEventManager.sendCommand(item?.hardware_id, primarySocketObjectEvent);
  }

  const handleSocketCommand = (item, thisImage) => {
    if (isPrivateMode) {
      return;
    }
    if (thisImage) {
      removeBordersFromCursorPointerImages();
      // add border class to the image which is clicked
      thisImage.classList.add('bordered');
    }
    if (state.isCompare) {
      /* Handle compare case for multiple units */
      setSelectedVideoItem(null);

      const unitId = parseInt(item?.property_id);
      const isDefault = item?.is_default === 'yes';
    
      let updatedImageArray = [...imageArray]; 
      // 1. Remove existing non-primary images from the same unit
      if (!isDefault) {
        updatedImageArray = updatedImageArray.filter(
          img => !(img.unit_id === unitId && !img.is_primary)
        );
      }
    
      // 2. Remove this image if already exists
      updatedImageArray = updatedImageArray.filter(
        img => img.image_id !== item?.id
      );
    
      const newImage = {
        unit_id: unitId,
        image_id: item?.id,
        is_primary: isDefault,
        image: item?.image_url,
        broker_id: userData.id,
        sub_sub_category_id: item?.sub_sub_category_id,
        type: "gallery_image",
        cross_fade: "yes",
      };
    
      // 3. Insert the new image
      if (isDefault) {
        updatedImageArray.push(newImage);
      } else {
        // insert just after primary image of same unit
        const insertIndex = updatedImageArray.findIndex(
          img => img.unit_id === unitId && img.is_primary
        );
        if (insertIndex !== -1) {
          updatedImageArray.splice(insertIndex + 1, 0, newImage);
        } else {
          updatedImageArray.push(newImage); // fallback if no primary found
        }
      }
    
      // 4. Get unique primary unit IDs in order
      const uniqueUnits = [];
      updatedImageArray.forEach(img => {
        if (img.is_primary && !uniqueUnits.includes(img.unit_id)) {
          uniqueUnits.push(img.unit_id);
        }
      });
    
      if (uniqueUnits.length > 4) {
        console.warn("Only 4 units allowed.");
        return;
      }
    
      // 5. Assign units to sockets
      const primaryUnits = [];
      const secondaryUnits = [];
    
      if (uniqueUnits.length === 1) {
        primaryUnits.push(uniqueUnits[0]);
      } else if (uniqueUnits.length === 2) {
        primaryUnits.push(uniqueUnits[0]);
        secondaryUnits.push(uniqueUnits[1]);
      } else if (uniqueUnits.length === 3) {
        primaryUnits.push(uniqueUnits[0], uniqueUnits[1]);
        secondaryUnits.push(uniqueUnits[2]);
      } else if (uniqueUnits.length === 4) {
        primaryUnits.push(uniqueUnits[0], uniqueUnits[1]);
        secondaryUnits.push(uniqueUnits[2], uniqueUnits[3]);
      }
    
      const unitHardwareMap = {};
      primaryUnits.forEach(unit => {
        unitHardwareMap[unit] = screenPlayerIdsRef.current.left;
      });
      secondaryUnits.forEach(unit => {
        unitHardwareMap[unit] = screenPlayerIdsRef.current.right;
      });
    
      // 6. Assign hardware_id to all images based on unit
      const finalImageArray = updatedImageArray.map(img => ({
        ...img,
        hardware_id: unitHardwareMap[img.unit_id],
        is_third_unit: uniqueUnits[2] === img.unit_id && img.is_primary ? "true" : "false",
      }));
    
      // 7. Group images by hardware
      const primarySocketObject = {
        hardware_id: screenPlayerIdsRef.current.left,
        left_image_url: '',
        right_image_url: '',
        type: "compare",
        hide_overlay_text: 0,
        image_array: JSON.stringify(finalImageArray.filter(img =>
          img.hardware_id === screenPlayerIdsRef.current.left
        )),
      };
    
      const secondarySocketObject = {
        hardware_id: screenPlayerIdsRef.current.right,
        left_image_url: '',
        right_image_url: '',
        type: "compare",
        hide_overlay_text: 0,
        image_array: JSON.stringify(finalImageArray.filter(img =>
          img.hardware_id === screenPlayerIdsRef.current.right
        )),
      };    
      // 8. Update state and send
      setImageArray(finalImageArray);    
      socketEventManager.sendCommand(primarySocketObject.hardware_id, primarySocketObject);
      socketEventManager.sendCommand(secondarySocketObject.hardware_id, secondarySocketObject);
    } else {
      /* Handle unit video case for single unit */
      setSelectedVideoItem(null);

      if (item.type === "unit_video") {
        
        setSelectedVideoItem(item);

        /* Send play video event */
        handleRotateLongPress(item, "play");
        handleRotateLongPress(item, "pause");

      } else {

        const primarySocketObject = {
          hardware_id: item?.hardware_id,
          broker_id: userData.id,
          sub_sub_category_id: item?.sub_sub_category_id,
          type: "gallery_image",
          image_id: item?.id,
          image_url: item?.image_url,
          cross_fade: "yes",
          unit_id: item?.id,
          is_primary: false,
          is_third_unit: false,
        } 
        console.log("primarySocketObject", primarySocketObject);
        socketEventManager.sendCommand(item?.hardware_id, primarySocketObject);
      }
    }
  }
  const getPropertyImagesList = async (item) => {
    console.log("getPropertyImagesList", item);
    try {
      
      setState((prevState) => ({
        ...prevState,
        propertyData: {
          ...prevState.propertyData,
          isLoading: true,
        },
      }));
      const response = await commonService({
        apiEndPoint: BROKER_ENDPOINT.getPropertyImages(
          location.state?.id || item?.category_id?.id,
          item?.id
        ),
      });
      setState((prevState) => {
        const updateState = {
          ...prevState,
          selectedRowsImages: [...prevState.selectedRowsImages, item],
        };

        return updateState;
      });

      setState((prevState) => {
        const updateState = {
          ...prevState,
        };
        if (prevState.isCompare) {
          updateState.compareImageLists = updateState.compareImageLists.map(
            (listItem) => {
              // send socket command for the first image
              handleSocketCommand(response?.data?.data?.[0]);

              if (listItem.item?.id === item?.id) {
                return { item, lists: response?.data?.data };
              }
              return listItem;
            }
          );
        } else {
          updateState.propertyData = {
            ...prevState.propertyData,
            lists: response?.data?.data,
          };
          updateState.compareImageLists = [
            { item, lists: response?.data?.data ?? [] },
          ];
          // send socket command for the first image
          handleSocketCommand(response?.data?.data?.[0]);
        }
        updateState.propertyData.isLoading = false;  

        return updateState;
      });
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        propertyData: {
          ...prevState.propertyData,
          isLoading: false,
        },
      }));
    }
  };

  // Separate function for removing images from compare mode
const handleRemoveFromCompare = (propertyId) => { 
  
  if (!state.isCompare) {
    return; // Only work in compare mode
  }
  
  // Remove all images from imageArray that have unit_id matching the property id
  let updatedImageArray = [...imageArray];
  updatedImageArray = updatedImageArray.filter(
    img => img.unit_id !== propertyId
  );
  // Update the imageArray state
  setImageArray(updatedImageArray);
  
  // Reorganize and send socket commands for remaining images
  if (updatedImageArray.length > 0) {
    // Get unique primary unit IDs in order from remaining images
    const uniqueUnits = [];
    updatedImageArray.forEach(img => {
      if (img.is_primary && !uniqueUnits.includes(img.unit_id)) {
        uniqueUnits.push(img.unit_id);
      }
    });
    
    if (uniqueUnits.length > 4) {
      console.warn("Only 4 units allowed.");
      return;
    }
    
    // Assign units to sockets
    const primaryUnits = [];
    const secondaryUnits = [];
    
    if (uniqueUnits.length === 1) {
      primaryUnits.push(uniqueUnits[0]);
    } else if (uniqueUnits.length === 2) {
      primaryUnits.push(uniqueUnits[0]);
      secondaryUnits.push(uniqueUnits[1]);
    } else if (uniqueUnits.length === 3) {
      primaryUnits.push(uniqueUnits[0], uniqueUnits[1]);
      secondaryUnits.push(uniqueUnits[2]);
    } else if (uniqueUnits.length === 4) {
      primaryUnits.push(uniqueUnits[0], uniqueUnits[1]);
      secondaryUnits.push(uniqueUnits[2], uniqueUnits[3]);
    }
    
    const unitHardwareMap = {};
    primaryUnits.forEach(unit => {
      unitHardwareMap[unit] = screenPlayerIdsRef.current.left;
    });
    secondaryUnits.forEach(unit => {
      unitHardwareMap[unit] = screenPlayerIdsRef.current.right;
    });
    
    // Assign hardware_id to all images based on unit
    const finalImageArray = updatedImageArray.map(img => ({
      ...img,
      hardware_id: unitHardwareMap[img.unit_id],
      is_third_unit: uniqueUnits[2] === img.unit_id && img.is_primary ? "true" : "false",
    }));
    
    // Group images by hardware
    const primarySocketObject = {
      hardware_id: screenPlayerIdsRef.current.left,
      left_image_url: '',
      right_image_url: '',
      type: "compare",
      hide_overlay_text: 0,
      image_array: JSON.stringify(finalImageArray.filter(img =>
        img.hardware_id === screenPlayerIdsRef.current.left
      )),
    };
    
    const secondarySocketObject = {
      hardware_id: screenPlayerIdsRef.current.right,
      left_image_url: '',
      right_image_url: '',
      type: "compare",
      hide_overlay_text: 0,
      image_array: JSON.stringify(finalImageArray.filter(img =>
        img.hardware_id === screenPlayerIdsRef.current.right
      )),
    };
    
    // Send socket commands
    socketEventManager.sendCommand(primarySocketObject.hardware_id, primarySocketObject);
    socketEventManager.sendCommand(secondarySocketObject.hardware_id, secondarySocketObject);
  } else {
    // If no images left, send empty arrays
    const emptyPrimarySocketObject = {
      hardware_id: screenPlayerIdsRef.current.left,
      left_image_url: '',
      right_image_url: '',
      type: "compare",
      hide_overlay_text: 0,
      image_array: JSON.stringify([]),
    };
    
    const emptySecondarySocketObject = {
      hardware_id: screenPlayerIdsRef.current.right,
      left_image_url: '',
      right_image_url: '',
      type: "compare",
      hide_overlay_text: 0,
      image_array: JSON.stringify([]),
    };
    
    socketEventManager.sendCommand(emptyPrimarySocketObject.hardware_id, emptyPrimarySocketObject);
    socketEventManager.sendCommand(emptySecondarySocketObject.hardware_id, emptySecondarySocketObject);
  }
};


  const handleSelectRow = (item) => {    
    const itemId = item?.id;

    if (state.isCompare) {
      setState((prevState) => {
        const currentSelectedRows = Array.isArray(prevState.selectTableRow)
          ? prevState.selectTableRow
          : [prevState.selectTableRow];

        const isSelected = currentSelectedRows.includes(itemId);

        let newSelectedRows = [...currentSelectedRows];
        let newCompareImageLists = [...prevState.compareImageLists];

        if (isSelected) {
          // Prevent deselecting the last remaining selected unit
          if (currentSelectedRows.length === 1) return prevState;

          newSelectedRows = currentSelectedRows.filter((id) => id !== itemId);
          newCompareImageLists = newCompareImageLists.filter(
            (listItem) => listItem?.item?.id !== itemId
          );
        } else {
          newSelectedRows.push(itemId);
          newCompareImageLists.push({ item });
        } 
 
        // Fetch images for the newly selected item (if it's a selection, not deselection)
         
        if (!isSelected) {
          getPropertyImagesList(item);
        } else {
          handleRemoveFromCompare(itemId);
        }

        return {
          ...prevState,
          selectTableRow: newSelectedRows,
          compareImageLists: newCompareImageLists,
        };
      });
    } else if (itemId !== state.selectTableRow) {
      getPropertyImagesList(item);
      setState((prevState) => ({
        ...prevState,
        selectTableRow: itemId,
        compareImageLists: [],
      }));
    }  
  };


  // Function to handle checkbox selection for any filter type
  const handleFilterChange = (filterType, value) => {
    setState((prevState) => {
      const updatedFilter = { ...prevState.selectFilter };

      // Check if the value already exists in the array
      const isSelected = updatedFilter[filterType].includes(value);

      // For radio button behavior:
      // If the item is already selected, deselect it (empty array)
      // If not selected, clear the array and add only this value
      if (isSelected) {
        updatedFilter[filterType] = [];
      } else {
        updatedFilter[filterType] = [value]; // Only allow one selection
      }

      // Apply all filters to get the new filtered lists
      const newFilteredLists = applyFilters(
        prevState.originalLists,
        updatedFilter,
        [value1[0], value1[1]], // price range
        [value2[0], value2[1]], // sqft range
        [value3[0], value3[1]]  // floor range
      );

      return {
        ...prevState,
        selectFilter: updatedFilter,
        lists: newFilteredLists,
        selectTableRow: newFilteredLists.length > 0
          ? prevState.isCompare
            ? prevState.selectTableRow
            : newFilteredLists[0].id
          : null
      };
    });
  }

  // Function to handle range slider changes
  const handleRangeChange = (rangeType, newValue) => {
    // Update the state for the specific range slider
    if (rangeType === "priceRange") {
      setValue1(newValue);
    } else if (rangeType === "squareFeetRange") {
      setValue2(newValue);
    } else if (rangeType === "floorRange") {
      setValue3(newValue);
    }

    // Apply filters with updated range values
    setState((prevState) => {
      const newFilteredLists = applyFilters(
        prevState.originalLists,
        prevState.selectFilter,
        rangeType === "priceRange" ? newValue : [value1[0], value1[1]],
        rangeType === "squareFeetRange" ? newValue : [value2[0], value2[1]],
        rangeType === "floorRange" ? newValue : [value3[0], value3[1]]
      );

      return {
        ...prevState,
        lists: newFilteredLists,
        selectTableRow:
          newFilteredLists.length > 0
            ? prevState.isCompare
              ? prevState.selectTableRow
              : newFilteredLists[0].id
            : null,
      };
    });
  };

  // Main filter application function


  // Function to reset all filters
  const handleResetFilter = () => {
    // Reset all filter states
    setState((prevState) => ({
      ...prevState,
      selectFilter: {
        bedroomCount: [],
        building: [],
        residenceType: [],
        entry: [],
        view: [],
        exterior: [],
        ceilingHeight: [],
        kitchenDining: [],
        bath: [],
        closet: [],
        bonusRooms: [],
        hvac: [],
      },
      lists: prevState.originalLists,
      // isOpenFilter: false,
      selectTableRow:
        prevState.originalLists.length > 0
          ? prevState.isCompare
            ? prevState.selectTableRow
            : prevState.originalLists[0].id
          : null,
    }));

    // Reset range slider values
    setValue1([0, max]);
    setValue2([0, max]);
    setValue3([0, floorMax]);
  };

  const getPageDetails = async () => {
    try {
      const response = await commonService({
        apiEndPoint: BROKER_ENDPOINT.getCategoryDetails(location.state?.id),
      });

      const responseData = response?.data?.data ?? [];

      // Extract left_screen_player_id and right_screen_player_id from the first item
      if (responseData[0]) {
        screenPlayerIdsRef.current.left = responseData[0].left_screen_player_id;
        screenPlayerIdsRef.current.right = responseData[0].right_screen_player_id;
      }

      setState((prevState) => ({
        ...prevState,
        isLoading: false,
        lists: responseData,
        originalLists: responseData, // Store original data for filtering
        filterDetails: response.data?.filter_values ?? {},
        selectTableRow: !prevState.isCompare
          ? responseData?.[0]?.id
          : prevState.selectTableRow,
      }));

      if (responseData?.[0]) {
        getPropertyImagesList(responseData[0]);
        setScreenPlayerIds({
          left: responseData[0].left_screen_player_id,
          right: responseData[0].right_screen_player_id,
        });        
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        isLoading: false,
        propertyData: {
          ...prevState.propertyData,
          isLoading: false,
        },
      }));
    }
  };

  const handleChangeCompare = (isChecked) => {
    setState((prevState) => ({
      ...prevState,
      isCompare: isChecked,
      selectTableRow: !isChecked
        ? state?.lists?.[0]?.id
        : prevState.selectTableRow,
    }));
    if (!isChecked) {
      if (state.lists?.[0]) {
        getPropertyImagesList(state.lists[0]);
      }
    }
  };

  const formatIndianNumber = (num) => {
    if (num === 0) return "0M";
    return `${num.toLocaleString("en-IN")}M`;
  };

  // const imageArray = [];

  const handleAfterSlide = (detail) => {
    const index = detail?.index; // The new slide index    
    const item = state?.propertyData?.lists?.[index];    
    if (item) {
      // handleSocketCommand(item);
    }
  };

  useEffect(() => {
    if (!location.state) {
      navigate("/");
    } else {
      getPageDetails();
    }
  }, []);

  // filter button toggle function
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const toggleFilter = () => setIsOpenFilter(!isOpenFilter);
  const closeFilter = () => setIsOpenFilter(false);

  useEffect(() => {
    // Just to use the variable and avoid the warning
    if (screenPlayerIds.left || screenPlayerIds.right) {
      // do nothing
    }
  }, [screenPlayerIds]);

  const galleryRef = useRef(null);
  const rotateRef = useRef(null);
  const longPressTimeout = useRef();
  const LONG_PRESS_DURATION = 500;


  useEffect(() => {
    function handleClickOutside(event) {
      if (
        galleryRef.current &&
        !galleryRef.current.contains(event.target) &&
        rotateRef.current &&
        !rotateRef.current.contains(event.target)
      ) {
        setSelectedVideoItem(null);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="mainContent_inner floorPlanPage">
      <Container fluid className="position-relative">
        <Link
          className="commonBack commonBack_topLeft text-uppercase d-block h-auto position-absolute"
          onClick={() => navigate(-1)}
        >
          <em className="icon-back" />
          <span className="d-block">Back</span>
        </Link>
        <div className="d-flex justify-content-between row">
          <Col
            md={6}
            className="imgGrid flex-shrink-0 d-flex flex-column align-items-center pe-xxl-5 pe-lg-4  justify-content-start"
          >
            <div className="imgGrid_inner d-flex flex-column">
              {state.propertyData.isLoading ? (
                <div className="d-flex justify-content-center align-items-center m-auto vh-100">
                  <Spinner />
                </div>
              ) : !state.propertyData.isLoading &&
                (state.propertyData?.lists?.length > 0 ||
                  (state.compareImageLists?.length > 0 && state.isCompare)) ? (
                <>
                  {state.isCompare ? (
                    state.compareImageLists.map((listItem, listItemIdx) => (
                      <div key={listItemIdx}>
                        {listItem?.lists?.length > 0 ? (
                          !state.isCompare && galleryEnabled ? (
                            isPrivateMode ? (
                              <LightGallery
                                elementClassNames="gallery-container row gx-2 gy-2"
                                speed={500}
                                mobileSettings={{
                                  controls: true,
                                  showCloseIcon: true,
                                  download: true,
                                }}
                                plugins={[lgThumbnail, lgZoom]}
                                onAfterSlide={handleAfterSlide}
                              >
                                <div>{listItem?.item?.unit}</div>

                                {listItem?.lists?.map((imageItem, imageItemIdx) => (
                                  <a
                                    key={imageItemIdx}
                                    href={imageItem?.image_url}
                                    className="imgGrid_item col-lg-4 col-6"
                                  >
                                    <ImageElement
                                      imageFor="user"
                                      previewSource={imageItem.type === "unit_video" ? imageItem?.thumb_url : imageItem?.image_url}
                                      // onClick={
                                      //   state.isCompare &&
                                      //     Array.isArray(state.selectTableRow) &&
                                      //     state.selectTableRow.length === 1 &&
                                      //     imageItemIdx === 0
                                      //     ? undefined // Disable click for first image in this case
                                      //     : () => handleSocketCommand(imageItem)
                                      // }
                                      className={`img-fluid bordered${state.isCompare && Array.isArray(state.selectTableRow) && state.selectTableRow.length === 1 && imageItemIdx === 0 ? ' selected-image' : ''}`}
                                      alt="floor-plan"
                                    />
                                    <h3 className="imgGrid_item_label text-uppercase mt-1">
                                      {imageItem?.title ?? "-"}
                                    </h3>
                                  </a>
                                ))}
                              </LightGallery>
                            ) : (
                              <div ref={galleryRef} className="gallery-container row gx-2 gy-2">
                                <div>{listItem?.item?.unit}</div>
                                {listItem?.lists?.map((imageItem, imageItemIdx) => (
                                  <div
                                    key={imageItemIdx}
                                    className="imgGrid_item col-lg-4 col-6 cursor-pointer"
                                  >
                                    <ImageElement
                                      imageFor="user"
                                      previewSource={imageItem?.type === "unit_video" ? imageItem?.thumb_url : imageItem?.image_url}
                                      className={`img-fluid ${state.isCompare && Array.isArray(state.selectTableRow) && state.selectTableRow.length === 1 && imageItemIdx === 0 ? ' selected-image' : ''}`}
                                      alt="floor-plan"
                                      onClick={
                                        state.isCompare &&
                                          Array.isArray(state.selectTableRow) &&
                                          state.selectTableRow.length === 1 &&
                                          imageItemIdx === 0
                                          ? undefined // Disable click for first image in this case
                                          : (e) => handleSocketCommand(imageItem, e.currentTarget)
                                      }
                                    />
                                    <h3 className="imgGrid_item_label text-uppercase mt-1">
                                      {imageItem?.title ?? "-"}
                                    </h3>
                                  </div>
                                ))}
                              </div>
                            )
                          ) : (
                            isPrivateMode ? (
                              <LightGallery
                                elementClassNames="gallery-container row gx-2 gy-2"
                                speed={500}
                                mobileSettings={{
                                  controls: true,
                                  showCloseIcon: true,
                                  download: true,
                                }}
                                plugins={[lgThumbnail, lgZoom]}
                                onAfterSlide={handleAfterSlide}
                              >
                                <div>{listItem?.item?.unit}</div>

                                {listItem?.lists?.map((imageItem, imageItemIdx) => (
                                  <a
                                    key={imageItemIdx}
                                    href={imageItem?.image_url}
                                    className="imgGrid_item col-lg-4 col-6"
                                  >
                                    <ImageElement
                                      imageFor="user"
                                      previewSource={imageItem.type === "unit_video" ? imageItem?.thumb_url : imageItem?.image_url}
                                      // onClick={
                                      //   state.isCompare &&
                                      //     Array.isArray(state.selectTableRow) &&
                                      //     state.selectTableRow.length === 1 &&
                                      //     imageItemIdx === 0
                                      //     ? undefined // Disable click for first image in this case
                                      //     : () => handleSocketCommand(imageItem)
                                      // }
                                      className={`img-fluid bordered${state.isCompare && Array.isArray(state.selectTableRow) && state.selectTableRow.length === 1 && imageItemIdx === 0 ? ' selected-image' : ''}`}
                                      alt="floor-plan"
                                    />
                                    <h3 className="imgGrid_item_label text-uppercase mt-1">
                                      {imageItem?.title ?? "-"}
                                    </h3>
                                  </a>
                                ))}
                              </LightGallery>
                            ) : (
                              <div ref={galleryRef} className="gallery-container row gx-2 gy-2">
                                <div>{listItem?.item?.unit}</div>
                                {listItem?.lists?.map((imageItem, imageItemIdx) => (
                                  <div
                                    key={imageItemIdx}
                                    className="imgGrid_item col-lg-4 col-6 cursor-pointer"
                                  >
                                    <ImageElement
                                      imageFor="user"
                                      previewSource={imageItem?.type === "unit_video" ? imageItem?.thumb_url : imageItem?.image_url}
                                      className={`img-fluid ${state.isCompare && Array.isArray(state.selectTableRow) && state.selectTableRow.length === 1 && imageItemIdx === 0 ? ' selected-image' : ''}`}
                                      alt="floor-plan"
                                      onClick={
                                        state.isCompare &&
                                          Array.isArray(state.selectTableRow) &&
                                          state.selectTableRow.length === 1 &&
                                          imageItemIdx === 0
                                          ? undefined // Disable click for first image in this case
                                          : (e) => handleSocketCommand(imageItem, e.currentTarget)
                                      }
                                    />
                                    <h3 className="imgGrid_item_label text-uppercase mt-1">
                                      {imageItem?.title ?? "-"}
                                    </h3>
                                  </div>
                                ))}
                              </div>
                            )
                          )
                        ) : (
                          <div className="d-flex justify-content-center align-items-center">
                            No data found
                          </div>
                        )}
                      </div>
                    ))
                  ) : (
                    isPrivateMode ? (
                      <LightGallery
                        elementClassNames="gallery-container row gx-2 gy-2"
                        speed={500}
                        mobileSettings={{
                          controls: true,
                          showCloseIcon: true,
                          download: true,
                        }}
                        plugins={[lgThumbnail, lgZoom]}
                        onAfterSlide={handleAfterSlide}
                      >
                        {state.propertyData.lists.map((listItem, idx) => (
                          <a
                            key={idx}
                            href={listItem.image_url}
                            className="imgGrid_item col-lg-4 col-6"
                          // onClick={state.isCompare ? (e) => { e.preventDefault(); e.stopPropagation(); } : undefined}
                          >
                            <ImageElement
                              imageFor="user"
                              previewSource={listItem?.type === "unit_video" ? listItem?.thumb_url : listItem?.image_url}
                              className="img-fluid bordered"
                              alt="floor-plan"
                              // onClick={() => handleSocketCommand(listItem)}
                            />
                            <h3 className="imgGrid_item_label text-uppercase mt-1">
                              {listItem?.title ?? "-"}
                            </h3>
                          </a>
                        ))}
                      </LightGallery>
                    ) : (
                      <div ref={galleryRef} className="gallery-container row gx-2 gy-2">
                        {state.propertyData.lists.map((listItem, idx) => (
                          <div
                            key={idx}
                            className="imgGrid_item col-lg-4 col-6 cursor-pointer"
                          >
                            <ImageElement
                              imageFor="user"
                              previewSource={listItem?.type === "unit_video" ? listItem?.thumb_url : listItem?.image_url}
                              className="img-fluid"
                              alt="floor-plan"
                              onClick={e => handleSocketCommand(listItem, e.currentTarget)}
                            />
                            <h3 className="imgGrid_item_label text-uppercase mt-1">
                              {listItem?.title ?? "-"}
                            </h3>
                          </div>
                        ))}
                      </div>
                    )
                  )}
                  {/* Global Rotate UI below gallery */}
                  {selectedVideoItem && (
                    <div className="rotate-container" ref={rotateRef}>
                      <button
                        style={{ border: "none", background: "none", cursor: "pointer" }}
                        className="rotate-container-btn rotate-container-btn-left"
                        // onClick={() => handleSocketCommand(selectedVideoItem)}
                        onMouseDown={() => {
                          longPressTimeout.current = setTimeout(() => handleRotateLongPress(selectedVideoItem, "press", "left"), LONG_PRESS_DURATION);
                        }}
                        onMouseUp={() => {
                          clearTimeout(longPressTimeout.current);
                          handleRotateLongPress(selectedVideoItem, "release", "left");
                        }}
                      >
                        <em className="icon-arrow-down" />
                      </button>
                      <span style={{ margin: "0 10px", fontWeight: 600 }}>ROTATE</span>
                      <button
                        style={{ border: "none", background: "none", cursor: "pointer" }}
                        className="rotate-container-btn rotate-container-btn-right"
                        // onClick={() => handleSocketCommand(selectedVideoItem)}
                        onMouseDown={() => {
                          longPressTimeout.current = setTimeout(() => handleRotateLongPress(selectedVideoItem, "press", "right"), LONG_PRESS_DURATION);
                        }}
                        onMouseUp={() => {
                          clearTimeout(longPressTimeout.current);
                          handleRotateLongPress(selectedVideoItem, "release", "right");
                        }}
                      >
                        <em className="icon-arrow-down" />
                      </button>
                    </div>
                  )}
                </>
              ) : (
                <div className="d-flex justify-content-center align-items-center vh-100">
                  No data found
                </div>
              )}
            </div>
          </Col>
          <Col
            md={6}
            className="floorPlanSec d-flex flex-column align-items-center ps-lg-0"
          >
            <div className="header w-100 d-flex align-items-center pe-1">
              <div className="header_title mx-auto">
                <h1 className="mb-0">Lounge Room</h1>
              </div>
              <Link className="header_logo" to={userRouteMap.LANDING.path}>
                <ImageElement
                  imageFor="user"
                  source="logo.svg"
                  className="img-fluid"

                />
              </Link>
            </div>
            <div
              className="floorPlanSec_title ms-auto" onClick={toggleFilter}
            >
              FILTERS <em className="icon-arrow-down ms-1" />
            </div>
            {isOpenFilter && (
              <>
                <div className="filterBox">
                  <div className="d-flex align-items-center justify-content-end">
                    {Object.values(state.selectFilter).some(
                      (arr) => arr.length > 0
                    ) ||
                      value1[0] > 0 ||
                      value1[1] < max ||
                      value2[0] > 0 ||
                      value2[1] < max ||
                      value3[0] > 0 ||
                      value3[1] < floorMax ? (
                      <div
                        className="clearBtn d-flex align-items-center me-xl-5 me-4"
                        onClick={handleResetFilter}
                      >
                        <span>CLEAR ALL</span>
                        <em className="icon-close ms-sm-2 ms-1" />
                      </div>
                    ) : null}
                    <div
                      // onClick={() =>
                      //   setState((prevState) => ({
                      //     ...prevState,
                      //     isOpenFilter: !prevState.isOpenFilter,
                      //   }))
                      // }
                      // aria-controls="filter-collapse"
                      // aria-expanded={state.isOpenFilter}
                      className="floorPlanSec_title" onClick={closeFilter}
                    >
                      FILTERS <em className="icon-arrow-up ms-1" />
                    </div>
                  </div>

                  <div className="filterBox_scroll"
                  // in={state.isOpenFilter}
                  >
                    <div className="filterBox_inner">
                      <div className="filterBox_content filterBox_content-1 mt-0">
                        <h2 className="filterBox_content_title">BEDROOM COUNT</h2>
                        <ul className="filterBox_content_list w_25 list-unstyled">
                          <li>
                            <Form.Check
                              type="checkbox"
                              id="Suites"
                              label="Suites"
                              className="diamond-checkbox"
                              checked={state.selectFilter.bedroomCount.includes(
                                "Suites"
                              )}
                              onChange={() =>
                                handleFilterChange("bedroomCount", "Suites")
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              id="1-Bedroom"
                              label="1 Bedroom"
                              className="diamond-checkbox"
                              checked={state.selectFilter.bedroomCount.includes(
                                "1"
                              )}
                              onChange={() =>
                                handleFilterChange("bedroomCount", "1")
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              id="2-Bedroom"
                              label="2 Bedroom"
                              className="diamond-checkbox"
                              checked={state.selectFilter.bedroomCount.includes(
                                "2"
                              )}
                              onChange={() =>
                                handleFilterChange("bedroomCount", "2")
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              id="3-Bedroom"
                              label="3 Bedroom"
                              className="diamond-checkbox"
                              checked={state.selectFilter.bedroomCount.includes(
                                "3"
                              )}
                              onChange={() =>
                                handleFilterChange("bedroomCount", "3")
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              id="4-Bedroom"
                              label="4 Bedroom"
                              className="diamond-checkbox"
                              checked={state.selectFilter.bedroomCount.includes(
                                "4"
                              )}
                              onChange={() =>
                                handleFilterChange("bedroomCount", "4")
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              id="5-Bedroom"
                              label="5 Bedroom"
                              className="diamond-checkbox"
                              checked={state.selectFilter.bedroomCount.includes(
                                "5"
                              )}
                              onChange={() =>
                                handleFilterChange("bedroomCount", "5")
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              id="7-Bedroom"
                              label="7 Bedroom"
                              className="diamond-checkbox"
                              checked={state.selectFilter.bedroomCount.includes(
                                "7"
                              )}
                              onChange={() =>
                                handleFilterChange("bedroomCount", "7")
                              }
                            />
                          </li>
                        </ul>
                      </div>
                      <div className="filterBox_content filterBox_content-2">
                        <h2 className="filterBox_content_title">BUILDING</h2>
                        <ul className="filterBox_content_list list-unstyled">
                          <li>
                            <Form.Check
                              type="checkbox"
                              id="South"
                              label="South"
                              className="diamond-checkbox"
                              checked={state.selectFilter.building.includes("S")}
                              onChange={() => handleFilterChange("building", "S")}
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              id="West"
                              label="West"
                              className="diamond-checkbox"
                              checked={state.selectFilter.building.includes("W")}
                              onChange={() => handleFilterChange("building", "W")}
                            />
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="filterBox_inner">
                      <div className="filterBox_content">
                        <div>
                          <h2 className="filterBox_content_title">
                            RESIDENCE TYPE
                          </h2>
                          <ul className="filterBox_content_list list-unstyled">
                            <li>
                              <Form.Check
                                type="checkbox"
                                label="Simplex"
                                className="diamond-checkbox"
                                checked={state.selectFilter.residenceType.includes(
                                  "Simplex"
                                )}
                                onChange={() =>
                                  handleFilterChange("residenceType", "Simplex")
                                }
                              />
                            </li>
                            <li>
                              <Form.Check
                                type="checkbox"
                                label="Duplex"
                                className="diamond-checkbox"
                                checked={state.selectFilter.residenceType.includes(
                                  "Duplex"
                                )}
                                onChange={() =>
                                  handleFilterChange("residenceType", "Duplex")
                                }
                              />
                            </li>
                            <li>
                              <Form.Check
                                type="checkbox"
                                label="Full Floor"
                                className="diamond-checkbox"
                                checked={state.selectFilter.residenceType.includes(
                                  "Full Floor"
                                )}
                                onChange={() =>
                                  handleFilterChange(
                                    "residenceType",
                                    "Full Floor"
                                  )
                                }
                              />
                            </li>
                            <li>
                              <Form.Check
                                type="checkbox"
                                label="Half Floor"
                                className="diamond-checkbox"
                                checked={state.selectFilter.residenceType.includes(
                                  "Half Floor"
                                )}
                                onChange={() =>
                                  handleFilterChange(
                                    "residenceType",
                                    "Half Floor"
                                  )
                                }
                              />
                            </li>
                            <li>
                              <Form.Check
                                type="checkbox"
                                label="Penthouse"
                                className="diamond-checkbox"
                                checked={state.selectFilter.residenceType.includes(
                                  "Penthouse"
                                )}
                                onChange={() =>
                                  handleFilterChange("residenceType", "Penthouse")
                                }
                              />
                            </li>
                            <li>
                              <Form.Check
                                type="checkbox"
                                label="Duplex PH"
                                className="diamond-checkbox"
                                checked={state.selectFilter.residenceType.includes(
                                  "Duplex PH"
                                )}
                                onChange={() =>
                                  handleFilterChange("residenceType", "Duplex PH")
                                }
                              />
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="filterBox_content">
                        <h2 className="filterBox_content_title">ENTRY</h2>
                        <ul className="filterBox_content_list list-unstyled">
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="Direct Elevator"
                              className="diamond-checkbox"
                              checked={state.selectFilter.entry.includes(
                                "Direct Elevator"
                              )}
                              onChange={() =>
                                handleFilterChange("entry", "Direct Elevator")
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="Service"
                              className="diamond-checkbox"
                              checked={state.selectFilter.entry.includes(
                                "Service"
                              )}
                              onChange={() =>
                                handleFilterChange("entry", "Service")
                              }
                            />
                          </li>
                        </ul>

                        <h2 className="filterBox_content_title mt-3">VIEW</h2>
                        <ul className="filterBox_content_list list-unstyled">
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="LR Downtown"
                              className="diamond-checkbox"
                              checked={state.selectFilter.view.includes(
                                "LR Downtown"
                              )}
                              onChange={() =>
                                handleFilterChange("view", "LR Downtown")
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="LR Midtown"
                              className="diamond-checkbox"
                              checked={state.selectFilter.view.includes(
                                "LR Midtown"
                              )}
                              onChange={() =>
                                handleFilterChange("view", "LR Midtown")
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="LR Water"
                              className="diamond-checkbox"
                              checked={state.selectFilter.view.includes(
                                "LR Water"
                              )}
                              onChange={() =>
                                handleFilterChange("view", "LR Water")
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="PBR Downtown"
                              className="diamond-checkbox"
                              checked={state.selectFilter.view.includes(
                                "PBR Downtown"
                              )}
                              onChange={() =>
                                handleFilterChange("view", "PBR Downtown")
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="PBR Midtown"
                              className="diamond-checkbox"
                              checked={state.selectFilter.view.includes(
                                "PBR Midtown"
                              )}
                              onChange={() =>
                                handleFilterChange("view", "PBR Midtown")
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="PBR Water"
                              className="diamond-checkbox"
                              checked={state.selectFilter.view.includes(
                                "PBR Water"
                              )}
                              onChange={() =>
                                handleFilterChange("view", "PBR Water")
                              }
                            />
                          </li>
                        </ul>
                      </div>
                      <div className="filterBox_content">
                        <h2 className="filterBox_content_title">EXTERIOR</h2>
                        <ul className="filterBox_content_list list-unstyled">
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="Terrace"
                              className="diamond-checkbox"
                              checked={state.selectFilter.exterior.includes(
                                "Terrace"
                              )}
                              onChange={() =>
                                handleFilterChange("exterior", "Terrace")
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="Open Loggia"
                              className="diamond-checkbox"
                              checked={state.selectFilter.exterior.includes(
                                "Open Loggia"
                              )}
                              onChange={() =>
                                handleFilterChange("exterior", "Open Loggia")
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="Covered Loggia"
                              className="diamond-checkbox"
                              checked={state.selectFilter.exterior.includes(
                                "Covered Loggia"
                              )}
                              onChange={() =>
                                handleFilterChange("exterior", "Covered Loggia")
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="Balcony"
                              className="diamond-checkbox"
                              checked={state.selectFilter.exterior.includes(
                                "Balcony"
                              )}
                              onChange={() =>
                                handleFilterChange("exterior", "Balcony")
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="500 SF+ Contiguous"
                              className="diamond-checkbox"
                              checked={state.selectFilter.exterior.includes(
                                "500 SF+ Contiguous"
                              )}
                              onChange={() =>
                                handleFilterChange(
                                  "exterior",
                                  "500 SF+ Contiguous"
                                )
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="Outdoor from DR"
                              className="diamond-checkbox"
                              checked={state.selectFilter.exterior.includes(
                                "Outdoor from DR"
                              )}
                              onChange={() =>
                                handleFilterChange("exterior", "Outdoor from DR")
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="Outdoor from LR"
                              className="diamond-checkbox"
                              checked={state.selectFilter.exterior.includes(
                                "Outdoor from LR"
                              )}
                              onChange={() =>
                                handleFilterChange("exterior", "Outdoor from LR")
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="Outdoor from PBR"
                              className="diamond-checkbox"
                              checked={state.selectFilter.exterior.includes(
                                "Outdoor from PBR"
                              )}
                              onChange={() =>
                                handleFilterChange("exterior", "Outdoor from PBR")
                              }
                            />
                          </li>
                        </ul>
                      </div>
                      <div className="filterBox_content">
                        <h2 className="filterBox_content_title">
                          CEILING HEIGHT
                        </h2>
                        <ul className="filterBox_content_list list-unstyled">
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="10' (LR)"
                              className="diamond-checkbox"
                              checked={state.selectFilter.ceilingHeight.includes(
                                "10' (LR)"
                              )}
                              onChange={() =>
                                handleFilterChange("ceilingHeight", "10' (LR)")
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="10'6\ (LR)"
                              className="diamond-checkbox"
                              checked={state.selectFilter.ceilingHeight.includes(
                                "10'6\" (LR)"
                              )}
                              onChange={() =>
                                handleFilterChange("ceilingHeight", "10'6\" (LR)")
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="22' (LR)"
                              className="diamond-checkbox"
                              checked={state.selectFilter.ceilingHeight.includes(
                                "22' (LR)"
                              )}
                              onChange={() =>
                                handleFilterChange("ceilingHeight", "22' (LR)")
                              }
                            />
                          </li>
                        </ul>

                        <h2 className="filterBox_content_title mt-3">
                          KITCHEN & DINING
                        </h2>
                        <ul className="filterBox_content_list list-unstyled">
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="Closed Kitchen"
                              className="diamond-checkbox"
                              checked={state.selectFilter.kitchenDining.includes(
                                "Closed Kitchen"
                              )}
                              onChange={() =>
                                handleFilterChange(
                                  "kitchenDining",
                                  "Closed Kitchen"
                                )
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="Open Kitchen"
                              className="diamond-checkbox"
                              checked={state.selectFilter.kitchenDining.includes(
                                "Open Kitchen"
                              )}
                              onChange={() =>
                                handleFilterChange(
                                  "kitchenDining",
                                  "Open Kitchen"
                                )
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="Eat-In Kitchen"
                              className="diamond-checkbox"
                              checked={state.selectFilter.kitchenDining.includes(
                                "Eat-In Kitchen"
                              )}
                              onChange={() =>
                                handleFilterChange(
                                  "kitchenDining",
                                  "Eat-In Kitchen"
                                )
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="Dining Room"
                              className="diamond-checkbox"
                              checked={state.selectFilter.kitchenDining.includes(
                                "Dining Room"
                              )}
                              onChange={() =>
                                handleFilterChange("kitchenDining", "Dining Room")
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="Breakfast Room"
                              className="diamond-checkbox"
                              checked={state.selectFilter.kitchenDining.includes(
                                "Breakfast Room"
                              )}
                              onChange={() =>
                                handleFilterChange(
                                  "kitchenDining",
                                  "Breakfast Room"
                                )
                              }
                            />
                          </li>
                        </ul>
                      </div>
                      <div className="filterBox_content">
                        <h2 className="filterBox_content_title">BATH</h2>
                        <ul className="filterBox_content_list list-unstyled">
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="Dual Primary Baths"
                              className="diamond-checkbox"
                              checked={state.selectFilter.bath.includes(
                                "Dual Primary Baths"
                              )}
                              onChange={() =>
                                handleFilterChange("bath", "Dual Primary Baths")
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="Steam Shower"
                              className="diamond-checkbox"
                              checked={state.selectFilter.bath.includes(
                                "Steam Shower"
                              )}
                              onChange={() =>
                                handleFilterChange("bath", "Steam Shower")
                              }
                            />
                          </li>
                        </ul>

                        <h2 className="filterBox_content_title mt-3">
                          WALK-IN CLOSET
                        </h2>
                        <ul className="filterBox_content_list list-unstyled">
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="PBR Dual Walk-In"
                              className="diamond-checkbox"
                              checked={state.selectFilter.closet.includes(
                                "PBR Dual Walk-In"
                              )}
                              onChange={() =>
                                handleFilterChange("closet", "PBR Dual Walk-In")
                              }
                            />
                          </li>
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="PBR Walk-In"
                              className="diamond-checkbox"
                              checked={state.selectFilter.closet.includes(
                                "PBR Walk-In"
                              )}
                              onChange={() =>
                                handleFilterChange("closet", "PBR Walk-In")
                              }
                            />
                          </li>
                        </ul>

                        <h2 className="filterBox_content_title mt-3">
                          BONUS ROOMS
                        </h2>
                        <ul className="filterBox_content_list list-unstyled">
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="Study/Office/Library"
                              className="diamond-checkbox"
                              checked={state.selectFilter.bonusRooms.includes(
                                "Study/Office/Library"
                              )}
                              onChange={() =>
                                handleFilterChange(
                                  "bonusRooms",
                                  "Study/Office/Library"
                                )
                              }
                            />
                          </li>
                        </ul>

                        <h2 className="filterBox_content_title mt-3">HVAC</h2>
                        <ul className="filterBox_content_list list-unstyled">
                          <li>
                            <Form.Check
                              type="checkbox"
                              label="No Jagas"
                              className="diamond-checkbox"
                              checked={state.selectFilter.hvac.includes(
                                "No Jagas"
                              )}
                              onChange={() =>
                                handleFilterChange("hvac", "No Jagas")
                              }
                            />
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="filterBox_inner">
                      <div className="filterBox_content w-100">
                        <h2 className="filterBox_content_title">RANGE SLIDERS</h2>
                        <Row className="g-lg-4">
                          <Col sm={4} xs={6}>
                            <div className="price-slider-wrapper rangeSlide">
                              <label className="price-label mb-3 mt-1">
                                PRICE
                              </label>
                              <RangeSlider
                                min={min}
                                max={max}
                                step={100000}
                                value={value1}
                                onInput={(values) => {
                                  setValue1(values);
                                  handleRangeChange("priceRange", values);
                                }}
                                className="custom-slider"
                              />
                              <div className="price-labels d-flex justify-content-between w-100 mt-3">
                                <span>{formatIndianNumber(value1[0])}</span>
                                <span>{formatIndianNumber(value1[1])}</span>
                              </div>
                            </div>
                          </Col>

                          <Col sm={4} xs={6}>
                            <div className="price-slider-wrapper rangeSlide">
                              <label className="price-label mb-3 mt-1">
                                SQUARE FEET
                              </label>
                              <RangeSlider
                                min={min}
                                max={max}
                                step={100000}
                                value={value2}
                                onInput={(values) => {
                                  setValue2(values);
                                  handleRangeChange("squareFeetRange", values);
                                }}
                                className="custom-slider"
                              />
                              <div className="price-labels d-flex justify-content-between w-100 mt-3">
                                <span>{formatIndianNumber(value2[0])}</span>
                                <span>{formatIndianNumber(value2[1])}</span>
                              </div>
                            </div>
                          </Col>

                          <Col sm={4} xs={6}>
                            <div className="price-slider-wrapper rangeSlide">
                              <label className="price-label mb-3 mt-1">
                                FLOOR
                              </label>
                              <RangeSlider
                                min={floorMin}
                                max={floorMax}
                                step={1}
                                value={value3}
                                onInput={(values) => {
                                  setValue3(values);
                                  handleRangeChange("floorRange", values);
                                }}
                                className="custom-slider"
                              />
                              <div className="price-labels d-flex justify-content-between w-100 mt-3">
                                <span>{value3[0]}</span>
                                <span>{value3[1]}</span>
                              </div>
                            </div>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="overlay" onClick={closeFilter} />
              </>
            )}
            <div className="floorPlanSec_table pe-lg-2">
              <Table hover className="commonTable border-0">
                <thead>
                  <tr>
                    <th>Tower</th>
                    <th className="w_200">Unit</th>
                    <th>Bed</th>
                    <th>Bath</th>
                    <th>Interior sf</th>
                    <th>Exterior sf</th>
                    <th>Price</th>
                    <th>Favorite</th>
                  </tr>
                </thead>
                {state.isLoading ? (
                  <tbody>
                    <tr>
                      <td colSpan="6">
                        <div className="d-flex justify-content-center m-auto p-3">
                          <Spinner />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                ) : !state.isLoading && state.lists.length > 0 ? (
                  <tbody>
                    {state.lists.map((listItem, idx) => (
                      <tr
                        key={idx}
                        className={`${state.selectTableRow === listItem?.id ||
                          (Array.isArray(state.selectTableRow) &&
                            state.selectTableRow?.includes?.(listItem?.id))
                          ? "table-active"
                          : ""
                          }`}
                        onClick={() => handleSelectRow(listItem)}
                      >
                        <td>
                          {listItem?.building === "S"
                            ? "South"
                            : listItem?.building === "W"
                              ? "West"
                              : listItem?.exposures || "-"}
                        </td>
                        <td>{listItem?.unit ?? "-"}</td>
                        <td>{(listItem?.bedrooms !== '') ? listItem?.bedrooms : "-"}</td>
                        <td>{listItem?.bathrooms ?? "-"}</td>
                        <td>
                          {listItem?.sqft_int
                            ? `${listItem?.sqft_int} SF`
                            : "-"}
                        </td>
                        <td>
                          {listItem?.exterior_area
                            ? `${listItem?.exterior_area} SF`
                            : "-"}
                        </td>
                        <td>
                          {listItem?.price
                            ? `$${listItem?.price.toLocaleString()} `
                            : "-"}
                        </td>
                        <td>
                          <span
                            className={`fav-diamond${favoriteUnits.includes(listItem.id) ? ' fav-diamond--filled' : ''}`}
                            onClick={e => {
                              e.stopPropagation();
                              handleFavChange(listItem.id);
                            }}
                            title={favoriteUnits.includes(listItem.id) ? 'Remove from favorites' : 'Add to favorites'}
                            role="checkbox"
                            aria-checked={favoriteUnits.includes(listItem.id)}
                            tabIndex={0}
                            onKeyDown={e => {
                              if (e.key === ' ' || e.key === 'Enter') {
                                e.preventDefault();
                                handleFavChange(listItem.id);
                              }
                            }}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                ) : (
                  <tbody>
                    <tr>
                      <td colSpan="6">
                        <div className="d-flex justify-content-center align-items-center">
                          No data found
                        </div>
                      </td>
                    </tr>
                  </tbody>
                )}
              </Table>
            </div>
            <div className="d-flex me-auto mt-2">
              {!state.isLoading && state.lists.length > 0 && (
                <div className="customSwitch d-flex align-items-center me-auto mt-auto">
                  <label className="switch">
                    <input
                      type="checkbox"
                      checked={state.isCompare}
                      onChange={(e) => {
                        setGalleryEnabled(e.target.checked)
                        handleChangeCompare(e.target.checked)
                      }}
                    />
                    <span className="slider" />
                  </label>
                  <span className="switchLabel">COMPARE</span>
                </div>
              )}
              {Object.values(state.selectFilter).some(
                (arr) => arr.length > 0
              ) ||
                value1[0] > 0 ||
                value1[1] < max ||
                value2[0] > 0 ||
                value2[1] < max ||
                value3[0] > 0 ||
                value3[1] < floorMax ? (
                <div
                  onClick={handleResetFilter}
                  className="clearBtn d-flex align-items-center me-auto mt-auto ms-md-4 ms-3"
                >
                  <em className="icon-close me-2" />
                  <span>CLEAR ALL</span>
                </div>
              ) : null}
            </div>
          </Col>
        </div>
      </Container>
    </div>
  );
}

export default MeetingFloorPlan;
